import $ from 'jquery';
import 'what-input';
import 'tablesaw/dist/tablesaw.jquery';
import './doc/add';
import './report/add-job';
import './contract/configure';
import './vehicle/lease';
import { Confirmation } from './lib/Application';

// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();
Tablesaw.init();

$('.js-confirm-delete').each(function () {
  const button = $(this);
  button.click(function (e) {
    e.preventDefault();
    const conf = new Confirmation({
      content: 'Czy na pewno chcesz usunąć ten element?',
      header: 'Usuwanie',
      buttons: [
        {
          label: 'Usuń',
          onclick: function () {
            window.location.href = button.attr('href');
          }
        },
        {
          label: 'Anuluj',
          class: 'secondary hollow clear',
          onclick: function () {
            conf.close();
          }
        }
      ]
    });
    return false;
  })
});
$('.js-confirm-reset-password').each(function () {
  const button = $(this);
  button.click(function (e) {
    e.preventDefault();
    const conf = new Confirmation({
      content: 'Czy na pewno chcesz wysłać do tego użytkownika wiadomość z odzyskaniem hasła?',
      header: 'Odzyskiwanie hasła',
      buttons: [
        {
          label: 'Wyślij',
          onclick: function () {
            window.location.href = button.attr('href');
          }
        },
        {
          label: 'Anuluj',
          class: 'secondary hollow clear',
          onclick: function () {
            conf.close();
          }
        }
      ]
    });
    return false;
  })
});

$('.input-error').each(function () {
  $(this).closest('.accordion-item').find('.accordion-title').addClass('errorous-section');
});

